document.addEventListener('DOMContentLoaded' , () => {
	const restorePasswordBtn = document.getElementById("restorePasswordBtn");
	const cancelRestoreBtn = document.getElementById("cancelRestoreBtn");

	const authForm = document.getElementById("authForm");
	const passwordRestoreForm = document.getElementById("passwordRestoreForm");

	const passwordRestoreCompleted = document.getElementById("passwordRestoreCompleted");

	if (restorePasswordBtn) {
		restorePasswordBtn.addEventListener('click', () => {
			authForm.classList.add("hidden");
			passwordRestoreForm.classList.add("block");
		})

		cancelRestoreBtn.addEventListener('click', () => {
			authForm.classList.remove("hidden");
			passwordRestoreForm.classList.remove("block");
		})

		passwordRestoreForm.addEventListener('submit', (e) => {
			e.preventDefault();
			const formData = new FormData(e.currentTarget);

			import("axios").then(({ default: axios }) =>{
				axios({
					method: 'post',
					url: '/service/',
					responseType: 'json',
					data: formData
				})
			})

			passwordRestoreCompleted.classList.add("block");
			passwordRestoreDone.classList.add("hidden");
		})
	}
})
